module.exports = new __parcel__URL__("notes.c9738615.png").toString();